// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1P3B_","rootCenter":"LoadMoreObserver_rootCenter__Oi2d5","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2_ILJ"};